import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa para usarlo?',
  a: 'No. Cada tomo está escrito en lenguaje clínico directo para que puedas aplicarlo desde el primer día, tanto si recién egresaste como si tienes años de práctica.'
}, {
  q: '¿Para qué especialidades de kine sirve?',
  a: 'Para kinesiólogos generalistas, deportivos, domiciliarios, pediátricos, respiratorios y obstétricos. El sistema cubre las áreas de mayor demanda en la práctica clínica.'
}, {
  q: '¿Está adaptado a mi país?',
  a: 'Completamente. El lenguaje, los ejemplos, los honorarios de seguros médicos y los contextos de práctica son universales y adaptables a cualquier país hispanohablante.'
}, {
  q: '¿Cuántas veces puedo imprimir el material?',
  a: 'Las veces que necesites. Para todos tus pacientes actuales y futuros. De por vida.'
}, {
  q: '¿En qué formato viene el material?',
  a: 'En PDF de alta calidad, listo para imprimir o usar en pantalla desde cualquier dispositivo.'
}, {
  q: '¿Qué pasa si no es lo que esperaba?',
  a: 'Tienes 7 días de garantía total. Si no cambia la manera en que organizas y ejecutas tus sesiones, te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal text-center mb-12" data-id="element-40">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-brand-cream/30" data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-43">
                <span className="font-bold text-brand-charcoal text-lg pr-4" data-id="element-44">
                  {faq.q}
                </span>
                <ChevronDown className={`text-brand-teal transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-45" />
              </button>
              <AnimatePresence data-id="element-46">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-47">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-48">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}